import { combineReducers } from 'redux';
import userReducer from '../views/auth/features/userSlice';
import plansReducer from './features/plansSlice';
import bundlesReducer from './features/bundlesSlice';
import allCurrencyReducer from './features/currenciesSlice';
import campaignsReducer from './features/campaignsSlice';
import usersReducer from '../views/users/features/usersSlice';
import transactionsReducer from '../views/transactions/features/transactionsSlice';
import transactionsReportReducer from '../views/transactions/features/transactionsReportSlice';
import domainsReducer from '../views/domains/features/domainsSlice';
import referralsReducer from '../views/referrals/features/referralsSlice';
import sourcePresetsReducer from '../views/sourcePresets/features/sourcePresetsSlice';
import presetCategoriesSlice from '../views/presetCategories/features/presetCategoriesSlice';
import networkPresetsReducer from '../views/networkPresets/features/networkPresetsSlice';
import promoCodesReducer from '../views/promoCodes/features/promoCodesSlice';
import newsPageReducer from '../views/news/features/newsPageSlice';
import dashboardReducer from '../views/dashboard/features/dashboardSlice';
import specialOffersReducer from '../views/specialOffers/features/specialOffersSlice';

const rootReducer = combineReducers({
  userReducer, // current user data
  plansReducer, // global data
  bundlesReducer, // global data
  allCurrencyReducer, // global data
  campaignsReducer, // global data
  usersReducer, // page
  transactionsReducer, // page
  transactionsReportReducer, // page
  specialOffersReducer, // page
  domainsReducer, // page
  referralsReducer, // page
  sourcePresetsReducer, // page
  presetCategoriesSlice, // page
  networkPresetsReducer, // page
  promoCodesReducer, // page
  newsPageReducer, // page
  dashboardReducer, // page
});

export default rootReducer;
